import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { EventEditController } from "./event-edit-controller";
import { EventEditPage } from "./event-edit-page";

/** `/events/new` and `/events/:eventId/edit`. */
export function EventEditRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { eventId = null } = useParams<{ eventId: string }>();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // Opened from the app, the form closes back to where it was opened, as iOS's sheet does; opened on its own, or once a
  // new show is made, the page it leads to takes its place. Never a new entry, or the system Back opens the form again.
  const opened = location.key !== "default";
  return (
    <Subtree
      key="event-edit"
      deps={[eventId]}
      controller={() =>
        new EventEditController(
          pick(deps, "client", "authHandler", "storeRepository", "locationsRepository", "countriesRepository"),
          { eventId, timeZone },
          {
            toShow: (id) => (eventId !== null && opened ? navigate(-1) : navigate(`/events/${id}`, { replace: true })),
            toList: () => (opened ? navigate(-1) : navigate("/events", { replace: true })),
          },
        )
      }
    >
      <EventEditPage />
    </Subtree>
  );
}
